const { wrapText, helpers } = require('../utils')
const renderLines = require('./render-lines')
const onClick = require('./on-click')
const iconLink = require('./components/icon-link')

const CHART_NODE_CLASS = 'org-chart-node'
const PERSON_LINK_CLASS = 'org-chart-person-link'
const PERSON_NAME_CLASS = 'org-chart-person-name'
const PERSON_TITLE_CLASS = 'org-chart-person-title'
const PERSON_DEPARTMENT_CLASS = 'org-chart-person-dept'
const PERSON_REPORTS_CLASS = 'org-chart-person-reports'

function formatMoney(amount, decimalCount = 0, decimal = ".", thousands = ",") {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    console.log(e)
  }
}

function wrap(text, width) {
  text.each(function () {
    var text = d3.select(this),
      words = text.text().split(/\s+/).reverse(),
      word,
      line = [],
      lineNumber = 0,
      lineHeight = 1.1, // ems
      x = text.attr('x'),
      y = text.attr('y'),
      dy = 0, // parseFloat(text.attr("dy")),
      tspan = text.text(null)
        .append('tspan')
        .attr('x', x)
        .attr('y', y)
        .attr('dy', dy + 'em')
    while (word = words.pop()) {
      line.push(word)
      tspan.text(line.join(' '))
      if (tspan.node().getComputedTextLength() > width) {
        line.pop()
        tspan.text(line.join(' '))
        line = [word]
        tspan = text.append('tspan')
          .attr('x', x)
          .attr('y', y)
          .attr('dy', ++lineNumber * lineHeight + dy + 'em')
          .text(word)
      }
    }
  })
}

function renderSelfTarget(nodeEnter,config){
  
  

  nodeEnter
    .append('rect')
    .attr('width', (node) => {

      let targets = node.kpi_targets.filter((target) => {
        return target.kpi_category_id === kpichart.selectedKpiType.id
      })

      // targets[0].value = 50000

      let total = targets.slice(0,new Date().getMonth())
      .reduce((total,current) => {
        return total += current.value
      },0)
      

      if (node.subordinateActualSalesTotal === 0 && node.selfActualSalesTotal === 0){
        return 0
      }

      // console.log(total);
      // console.log(node.selfTargetTotal);
      // console.log((total / node.selfTargetTotal) > 1 ? (config.nodeWidth - 20) : (config.nodeWidth - 20) * (total / node.selfTargetTotal));
      
      return (total / node.selfTargetTotal) > 1 ? (config.nodeWidth - 20) : (config.nodeWidth - 20) * (total / node.selfTargetTotal)   
 
    })
    .attr('height', 30)
    .attr('id', d => d.id)
    .attr('fill', (node) => {
      return config.notIdealColor
    })
    .attr('x', 10)
    .attr('y', config.selfTargetPositionY)
    .style('cursor', 'default')
    .attr('rx', config.nodeBorderRadius)
    .attr('ry', config.nodeBorderRadius)

  nodeEnter // for current sales background marking
    .append('rect')
    .attr('width', (node) => {
      if (node.selfTargetTotal > 0) {

        if (node.subordinateActualSalesTotal > 0) {
          return node.subordinateActualSalesTotal / node.selfTargetTotal > 1 ? config.nodeWidth - 20 : (config.nodeWidth - 20) * node.subordinateActualSalesTotal / node.selfTargetTotal
        } else {
          return node.selfActualSalesTotal / node.selfTargetTotal > 1 ? config.nodeWidth - 20 : (config.nodeWidth - 20) * node.selfActualSalesTotal / node.selfTargetTotal
        }

      } else {
        return config.nodeWidth - 20 // if unset
      }
    })
    .attr('height', 30)
    .attr('id', d => d.id)
    .attr('fill', (node) => {
      return node.selfTargetTotal > 0 ? config.successColor : config.neutralColor
    })
    .attr('x', 10)
    .attr('y', config.selfTargetPositionY)
    .style('cursor', 'default')
    .attr('rx', config.nodeBorderRadius)
    .attr('ry', config.nodeBorderRadius)



  nodeEnter
    .append('text')
    .attr('x', 20)
    .attr('y', config.selfTargetPositionY + config.textPaddingY)
    .style('font-weight', 500)
    .text('Self Target')
    .style('cursor', 'default')   


  nodeEnter
    .append('text')
    .attr('x', 115)
    .attr('y', config.selfTargetPositionY + config.textPaddingY)
    .style('font-weight', 500)
    .style('font-size', 13)
    .text((node) => {
      return node.subordinateActualSalesTotal > 0 ?
        formatMoney(node.subordinateActualSalesTotal) + '/' + formatMoney(node.selfTargetTotal) :
        formatMoney(node.selfActualSalesTotal) + '/' + formatMoney(node.selfTargetTotal)
      
      
    })
    .style('cursor', 'default')
    .on('click', () => {
      d3.event.stopPropagation()
    })

    
}

function renderSubordinateTarget(nodeEnter,config){

  nodeEnter
    .append('rect')
    .attr('width', config.nodeWidth - 20)
    .attr('height', 30)
    .attr('id', d => d.id)
    .attr('fill', (node) => {

      if (!node._children && !node.children){
        return config.neutralColor    
      }
      
      if (node._children && node._children.length===0){
        return config.neutralColor    
      } 

      if (node.children && node.children.length===0) {
        return config.neutralColor
      } 

      if (node.subordinateTotal === 0 && node.selfTargetTotal ===0){
        return config.neutralColor        
      } else if (node.subordinateTotal/node.selfTargetTotal===1) {
        return config.successColor
      } else if (node.subordinateTotal/node.selfTargetTotal < 1){
        return config.dangerColor        
      } else if (node.subordinateTotal / node.selfTargetTotal > 1) {
        return config.notIdealColor
      }    
      
    })
    .attr('x', 10)
    .attr('y', config.subordinatePositionY)
    .style('cursor', 'default')
    .attr('rx', config.nodeBorderRadius)
    .attr('ry', config.nodeBorderRadius)


  nodeEnter
    .append('text')
    .attr('x', 20)
    .attr('y', config.subordinatePositionY + config.textPaddingY)
    .style('font-weight', 500)
    .text('Subordinate')
    .style('cursor', 'default')


  nodeEnter
    .append('text')
    .attr('x', 115)
    .attr('y', config.subordinatePositionY + config.textPaddingY)
    .style('font-weight', 500)
    .style('font-size', 13)
    .text((node) => {

      // if (node._children && node._children.length === 0) {
      //   return 'No Subordinate'
      // }

      // if (node.children && node.children.length === 0) {
      //   return 'No Subordinate'
      // } 

      // if (node.selfTargetTotal ===0){
      //   return 0
      // }

      // return node.subordinateTotal

      // return formatMoney(node.subordinateTotal).toString() + ' (' +
      //   (node.subordinateTotal / node.selfTargetTotal * 100).toFixed(0).toString() + '%' + ')'

      return node.selfTargetTotal > 0 ?
        formatMoney(node.subordinateTotal).toString() + ' (' +
        (node.subordinateTotal / node.selfTargetTotal * 100).toFixed(0).toString() + '%' + ')'
        : 'Not Allocated'
      // return "50,000 (50%)"
    })
    .style('cursor', 'default')
    

}

function renderFeedback(nodeEnter,config){
  // nodeEnter
  //   .append('rect')
  //   .attr('width', config.nodeWidth - 20)
  //   .attr('height', 30)
  //   .attr('id', d => d.id)
  //   .attr('fill', (node) => {
      
  //     if (node.selfTargetTotal === 0) {
  //       return config.neutralColor
  //     } else if (node.feedbackTotal / node.selfTargetTotal === 1) {
  //       return config.successColor
  //     } else if (node.feedbackTotal / node.selfTargetTotal < 1) {
  //       return config.dangerColor
  //     } else if (node.feedbackTotal / node.selfTargetTotal > 1) {
  //       return config.notIdealColor
  //     }   
  //   })
  //   .attr('x', 10)
  //   .attr('y', config.feedbackPositionY)
  //   .attr('rx', config.nodeBorderRadius)
  //   .attr('ry', config.nodeBorderRadius)
  //   .style('cursor', 'default')


  //   // .on('mouseover',(node) => {
  //   //   if (node.kpi_target_feedback.length > 0){
  //   //     // document.getElementById('feedbackTooltip' + node.id).style.visibility = 'visible'
  //   //     // document.getElementById('feedbackTooltipBackground' + node.id).style.visibility = 'visible'
  //   //   }
     
  //   //   // console.log(document.getElementById('tooltip' + node.id).style);
  //   // })
  //   // .on('mouseout', (node) => {
  //   //   if (node.kpi_target_feedback.length > 0) {
  //   //     // document.getElementById('feedbackTooltip' + node.id).style.visibility = 'hidden'
  //   //     // document.getElementById('feedbackTooltipBackground' + node.id).style.visibility = 'hidden'
  //   //   }      
  //   // })

  // //  nodeEnter
  // //   .filter((node) => {
  // //     return node.kpi_target_feedback.length > 0 ? true : false
  // //   })
  // //   .append('rect')
  // //   .attr("id", (node) => {
  // //     return 'feedbackTooltipBackground' + node.id
  // //   })
  // //   .style("visibility", "hidden")
  // //   .attr('width', 200)
  // //   .attr('height', 50)
  // //   .attr('opacity', 0.8)
  // //   .attr('x', 235)
  // //   .attr('y', 140)
  // //   .attr('fill', "lightblue")
  // //   .attr('rx', config.nodeBorderRadius)
  // //   .attr('ry', config.nodeBorderRadius)

  // nodeEnter
  //   .filter((node) => {
  //     return node.kpi_target_feedback.length > 0 ? true : false
  //   })
  //   .append("title")
  //   .attr("id", (node) => {
  //     return 'feedbackTooltip' + node.id
  //   })
  //   //  .append('rect:title')
  //   // .append('rect')
  //   // .style('cursor', 'default')
  //   // .attr('font-weight', 800)
  //   // .style("pointer-events", "none")
  //   .text((node)=>{
  //     // return a"I'm a circle! asdadasd asdasdasd asdasdasd asdasd adasdasdas asdasd asdada sdasdd adssd"
  //     return "Latest Feedback from person: " + node.feedbackRemark
  //   })


  // nodeEnter
  //   .append('text')
  //   .attr('x', 20)
  //   .attr('y', config.feedbackPositionY + config.textPaddingY)
  //   .style('font-weight', 500)
  //   .text('Feedback')
  //   .style('cursor', 'default')


  // nodeEnter
  //   .append('text')
  //   .attr('x', 115)
  //   .attr('y', config.feedbackPositionY + config.textPaddingY)
  //   .style('font-weight', 500)
  //   .style('font-size', 13)
  //   .text((node) => {
  //     // return "500,000 (50%)" 
  //     return node.selfTargetTotal > 0 ?
  //       formatMoney(node.feedbackTotal).toString() + ' (' +
  //       (node.feedbackTotal / node.selfTargetTotal * 100).toFixed(0).toString() + '%' + ')'
  //       : 'No Target'
  //   })
  //   .style('cursor', 'default')

}

function render (config) {
  const {
    svgroot,
    svg,
    tree,
    animationDuration,
    nodeWidth,
    nodeHeight,
    nodePaddingX,
    nodePaddingY,
    nodeBorderRadius,
    backgroundColor,
    nameColor,
    titleColor,
    reportsColor,
    borderColor,
    avatarWidth,
    lineDepthY,
    treeData,
    sourceNode,
    onPersonLinkClick,
  } = config

  // Compute the new tree layout.
  const nodes = tree.nodes(treeData).reverse()
  const links = tree.links(nodes)

  config.links = links
  config.nodes = nodes

  // Normalize for fixed-depth.
  nodes.forEach(function (d) {
    d.y = d.depth * lineDepthY
  })

  // Update the nodes
  const node = svg
    .selectAll('g.' + CHART_NODE_CLASS)
    .data(nodes.filter(d => d.id), d => d.id)
  const parentNode = sourceNode || treeData

  // Enter any new nodes at the parent's previous position.
  const nodeEnter = node
    .enter()
    .insert('g')
    .attr('class', CHART_NODE_CLASS)
    .attr('transform', `translate(${parentNode.x0}, ${parentNode.y0})`)
    .on('click', onClick(config))

  // Person Card Shadow
  nodeEnter
    .append('rect')
    .attr('width', nodeWidth)
    .attr('height', nodeHeight)
    .attr('fill', backgroundColor)
    .attr('stroke', borderColor)
    .attr('rx', nodeBorderRadius)
    .attr('ry', nodeBorderRadius)
    .attr('fill-opacity', 0.05)
    .attr('stroke-opacity', 0.025)
    .attr('filter', 'url(#boxShadow)')

  // Person Card Container
  nodeEnter
    .append('rect')
    .attr('width', nodeWidth)
    .attr('height', nodeHeight)
    .attr('id', d => d.id)
    .attr('fill', backgroundColor)
    .attr('stroke', borderColor)
    .attr('rx', nodeBorderRadius)
    .attr('ry', nodeBorderRadius)
    .style('cursor', helpers.getCursorForNode)
    .attr('class', 'box')

  const namePos = {
    x: nodePaddingX * 1.4 + avatarWidth,
    y: nodePaddingY * 1.8
  }

  // Person's Name

  function wrap (text, width) {
    text.each(function () {
      var text = d3.select(this),
        words = text.text().split(/\s+/).reverse(),
        word,
        line = [],
        lineNumber = 0,
        lineHeight = 1.1, // ems
        x = text.attr('x'),
        y = text.attr('y'),
        dy = 0, // parseFloat(text.attr("dy")),
        tspan = text.text(null)
          .append('tspan')
          .attr('x', x)
          .attr('y', y)
          .attr('dy', dy + 'em')
      while (word = words.pop()) {
        line.push(word)
        tspan.text(line.join(' '))
        if (tspan.node().getComputedTextLength() > width) {
          line.pop()
          tspan.text(line.join(' '))
          line = [word]
          tspan = text.append('tspan')
            .attr('x', x)
            .attr('y', y)
            .attr('dy', ++lineNumber * lineHeight + dy + 'em')
            .text(word)
        }
      }
    })
  }

  nodeEnter
    .append('text')
    .attr('class', PERSON_NAME_CLASS)
    .attr('x', namePos.x)
    .attr('y', namePos.y)
    .attr('dy', '.3em')
    .style('cursor', 'default')
    .style('fill', nameColor)
    .style('font-size', 14)
    .text((d) => {
      return d.person.name.substring(0, 32) + (d.person.name.length > 32 ? '...' : '')
    })
    .call(wrap, 170)

  nodeEnter
    .append('text')
    .attr('class', PERSON_NAME_CLASS)
    .attr('x', 10)
    .attr('y', 190)
    .attr('dy', '.3em')
    .style('cursor', 'default')
    .style('fill', nameColor)
    .style('font-size', 11)
    .text((d) => {
      return d.branch_name 
      ? d.branch_name
      : '' 
      // return d.person.name.substring(0, 32) + (d.person.name.length > 32 ? '...' : '')
    })
    .call(wrap, 190)

  // Person's Title
  nodeEnter
    .append('text')
    .attr('class', PERSON_TITLE_CLASS + ' unedited')
    .attr('x', namePos.x)
    .attr('y', namePos.y + nodePaddingY * 1.8 + 3)
    .attr('dy', '0.1em')
    .style('font-size', 14)
    .style('cursor', 'default')
    .style('fill', titleColor)
  
    // .text(d => "KUL/PLS/SBH/SGR/SRW")
    .text(d => d.person.title === 'No region' ? '' : d.person.title)

  renderSelfTarget(nodeEnter,config)
  renderSubordinateTarget(nodeEnter, config)
  renderFeedback(nodeEnter, config)


  const heightForTitle = 45 // getHeightForText(d.person.title)

  // Person's Reports
  nodeEnter
    .append('text')
    .attr('class', PERSON_REPORTS_CLASS)
    .attr('x', 13)
    .attr('y', nodeHeight-30)
    .attr('dy', '.9em')
    .style('font-size', 14)
    .style('font-weight', 500)
    .style('cursor', 'pointer')
    .style('fill', reportsColor)
    .text(helpers.getTextForTitle)

  // Person's Avatar
  nodeEnter
    .append('image')
    .attr('width', avatarWidth)
    .attr('height', avatarWidth)
    .attr('x', nodePaddingX)
    .attr('y', nodePaddingY)
    .attr('stroke', borderColor)
    .attr('src', d => d.person.avatar)
    .attr('xlink:href', d => d.person.avatar)
    .attr('clip-path', 'url(#avatarClip)')

  // Person's Department
  nodeEnter
  .append('text')
  .attr('class', getDepartmentClass)
  .attr('x', namePos.x / 3.2)
  .attr('y', namePos.y + nodePaddingY * 8)
  .attr('dy', '.9em')
  .style('cursor', 'pointer')
  .style('fill', helpers.getColor)
  .style('font-weight', 600)
  .style('font-size', 10)
  .text(helpers.getTextForDepartment)

  // nodeEnter.append("svg:circle")
  //  .append("svg:title")
  // .text(function (d) { return d.feedbackRemark; });

  // Person's Link
  // const nodeLink = nodeEnter
  //   .append('a')
  //   .attr('class', PERSON_LINK_CLASS)
  //   .attr('xlink:href', d => d.person.link || '')
  //   .on('click', datum => {
  //     d3.event.stopPropagation()
  //     // TODO: fire link click handler
  //     // console.log(datum)
  //     console.log(kpichart.getFullOrgChartData())
      
  //     // if (onPersonLinkClick) {
  //     //   onPersonLinkClick(datum, d3.event)
  //     // }
  //   })

  // iconLink({
  //   svg: nodeLink,
  //   x: nodeWidth - 28,
  //   y: nodeHeight - 28
  // })


  node
    .filter((n) => {
      return ((n._children || []).length !== 0 || (n.children || []).length !== 0) 
      // && n.depth===0
      // && n.employee_uid === kpichart.currentEmployee.employee_uid
    })
    .append('text')
    .attr('class', 'fa') // Give it the font-awesome class
    .text('\uf044') // Specify your icon in unicode
    .attr('x', nodeWidth - 40)
    .attr('y', nodeHeight - 15)
    .style('font-size', 20)
    .style('cursor', 'pointer')
    .on('click', datum => {
      d3.event.stopPropagation()
      // TODO: fire link click handler
      // console.log(datum)

      let subordinates = {}
      let selfTarget = Object.assign([], datum.kpi_targets)
      if (datum.children) {
        subordinates = datum.children.map(a => Object.assign({}, a))
      } else {
        subordinates = datum._children.map(a => Object.assign({}, a))
      }

      if (datum.depth === 0 && datum.employee_uid === kpichart.currentEmployee.employee_uid && kpichart.$hasPermissionTo(['kpi self update'])){
        subordinates.push(Object.assign({}, datum))
      }
      
      kpichart.showCard(subordinates,selfTarget)
      
      // kpichart.showCard(datum.children.map(a => Object.assign({}, a)) || datum._children.map(a => Object.assign({}, a)))
      // console.log(kpichart.getFullOrgChartData())
      // if (onPersonLinkClick) {
      //   onPersonLinkClick(datum, d3.event)
      // }
    })
    // .append('a')

  // Transition nodes to their new position.
  const nodeUpdate = node
    .transition()
    .duration(animationDuration)
    .attr('transform', d => `translate(${d.x},${d.y})`)

  nodeUpdate
    .select('rect.box')
    .attr('fill', backgroundColor)
    .attr('stroke', helpers.getColor)

  // Transition exiting nodes to the parent's new position.
  const nodeExit = node
    .exit()
    .transition()
    .duration(animationDuration)
    .attr('transform', d => `translate(${parentNode.x},${parentNode.y})`)
    .remove()

  // Update the links
  const link = svg.selectAll('path.link').data(links, d => d.target.id)

  // Wrap the title texts
  const wrapWidth = 140

  svg.selectAll('text.unedited.' + PERSON_TITLE_CLASS).call(wrapText, wrapWidth)

  // Render lines connecting nodes
  renderLines(config)

  // Stash the old positions for transition.
  nodes.forEach(function (d) {
    d.x0 = d.x
    d.y0 = d.y
  })
}

function getDepartmentClass (d) {
  const deptClass = d.departmentName ? d.departmentName.toLowerCase() : ''

  return [PERSON_DEPARTMENT_CLASS, deptClass].join(' ')
}

module.exports = render
